import React, { FC } from 'react';

import {
    VodPlayerController,
    VodPlayerControllerProps,
} from '../../../../vod-player/ui/VodPlayerController';
import { useVideoToken } from '../../../../film-player/hooks/use-video-token';

export const FilmPlayerController: FC<VodPlayerControllerProps> = ({ contentId, ...props }) => {
    const videoToken = useVideoToken(contentId);

    return <VodPlayerController contentId={contentId} videoToken={videoToken} {...props} />;
};
